<template>
  <div class="hero">
    <div class="hero__text">
      <h2 v-html="texts.title"></h2>
      <p v-html="texts.text"></p>
    </div>
    <div class="container slider mobile" v-if="slider.length">
      <template v-for="(feedback, index) in sliderMobile">
        <transition-group name="slide-fade" mode="out-in">
          <div
            class="feedback slide slide__image"
            @click="showFeedbacks = !showFeedbacks"
            v-if="index === currentSlideM && feedback.logo"
            :key="`logo-${index}`">
            <div class="feedback__mobile-text" v-html="texts.feedback"></div>
            <div
              class="feedback__image"
              :style="[feedback.logo ? { 'background-image': `url(${require('@/assets/' + feedback.logo)})` } : '']"></div>
          </div>
        </transition-group>
        <transition-group name="slide-fade" mode="out-in">
          <div
            class="feedback slide slide__text"
            @click="showFeedbacks = !showFeedbacks"
            v-if="index === currentSlideM && feedback.content"
            :key="`content-${index}`">
            <p v-html="feedDescription(feedback.content)"></p>
          </div>
        </transition-group>
      </template>
    </div>
    <div class="container slider pc" v-if="slider.length">
      <transition-group name="slide-fade" mode="out-in">
        <div
          v-show="index === currentSlide"
          v-for="(feedback, index) in slider"
          @click="showFeedbacks = !showFeedbacks"
          class="feedback slide slide__text"
          :key="`feedback-${feedback.id}`">
          <div
            class="feedback__image"
            :style="[feedback.logo ? { 'background-image': `url(${require('@/assets/' + feedback.logo)})` } : '']"></div>
          <p class="feedback__text" v-html="feedDescription(feedback.content)"></p>
        </div>
      </transition-group>
    </div>
    <div class="feedback_title" v-if="slider.length" v-html="texts.feedback"></div>
    <transition name="fade">
      <Feedbacks v-if="showFeedbacks" v-on:closeFeedbacks="showFeedbacks = false"/>
    </transition>
  </div>
</template>

<script>
import Feedbacks from './Feedbacks.vue';

export default {
  name: 'Hero',
  data () {
    return {
      currentSlide: 0,
      currentSlideM: 0,
      time: 5,
      timeConstant: 1,
      timer: null,
      timerMobile: null,
      maxDescLength: 140,
      showFeedbacks: false
    }
  },
  methods: {
    feedDescription(desc) {
      return (desc.length < this.maxDescLength) ? desc : `${desc.substr(0, this.maxDescLength)} ...`;
    },
    autoPlay() {
      this.timer = setInterval(() => {
        this.currentSlide < this.slider.length - 1 ? this.currentSlide += 1 : this.currentSlide = 0;
      }, 5000);
    },
    autoPlayMobile() {
      this.timerMobile = setInterval(() => {
        this.currentSlideM < this.sliderMobile.length - 1 ? this.currentSlideM += 1 : this.currentSlideM = 0;
        // }
      }, 5000);
    },
  },
  computed: {
    state() {
      return this.$root.$data.state;
    },
    texts() {
      return this.state.system.header;
    },
    slider() {
      return this.state.feedbacks;
    },
    sliderMobile() {
      const fb = this.slider;
      const fbMobile = [];
      fb.filter((content, index) => {
        if (content.logo) fbMobile.push({logo: content.logo});
        if (content.content) fbMobile.push({content: content.content});
      });
      return fbMobile;
    },
  },
  mounted() {
    if(this.slider.length) {
      this.autoPlay();
      this.autoPlayMobile();
    }
  },
  beforeUpdate() {
    // if(this.slider.length) {
    //   setTimeout(() => {
    //     this.currentSlide = [0,0];
    //     this.showCurrent(1);
    //     clearInterval(this.timer);
        // this.autoPlay();
    //   },50);
    // } else {
    //   this.currentSlide = [0,0];
    //   this.showCurrent(1);
    //   clearInterval(this.timer);
    // }
  },
  components: {
    Feedbacks
  },
};
</script>

<style scoped lang="stylus">

@import '../../styles/common.styl'

@keyframes slide-from-left
  from
    transform translateX(100%)
  to
    transform none

@keyframes slide-from-right
  from
    transform translateX(-100%)
  to
    transform none

.fade-enter-active,
.fade-leave-active
  transition opacity .5s
.fade-enter,
.fade-leave-to
  opacity 0

.slide-fade-enter-active,
.slide-fade-leave-active
  transition all .4s ease
  // transition all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0)
.slide-fade-enter
  transform translateX(50%)
  opacity 0
.slide-fade-enter-to,
.slide-fade-leave
  transform translateX(0%)
  opacity 1
.slide-fade-leave-to
  transform translateX(-50%)
  opacity 0

.hero
  background-repeat no-repeat
  position relative
  background-color $OTSnavBlue
  margin-top 90px
  overflow hidden
  &::before
    content ''
    position absolute
    top 0
    bottom 0
    left 41%
    right 0
    background-image url('../../assets/hero.png')
    background-size 100%
    background-size cover
    background-position center
    opacity .4
    +tablet()
      left 0
  .feedback_title
    max-width 996px
    margin 0 auto
    position absolute
    top auto
    bottom 42px
    left 0
    right 0
    pointer-events none
    transform translateY(50%)
    +tablet()
      bottom 52px
    +mobile()
      bottom 62px
      left 20px
      display none
    @media (max-width: 400px)
      height 72px
    +mobileXS()
      height 82px
  .container
    position relative
    height 80px
    max-width none
    background-color #fff
    overflow hidden
    border-bottom 2px solid $OTSnavBlue
    cursor pointer
    +tablet()
      height 90px
    +mobile()
      height 90px
    @media (max-width: 400px)
      height 90px
    +mobileXS()
      height 120px

  &__text
    text-align center
    color #e2e2e2
    font-weight 300
    padding 60px 0
    +mobile()
      padding 20px 30px
    h2
      font-size 28px
      line-height 1.5em
      font-weight 300
      +mobile()
        font-size 24px
        line-height 1.5em
        padding-top 25px
        margin-bottom 0.5em
    p
      font-size 18px
      line-height 2.2em
      +mobile()
        font-size 18px
        line-height 1.8em
        margin 0 10px
  .slider
    display flex
    justify-content center
    align-items center
    &.mobile
      display none
      +tablet()
        display flex
    &.pc
      +tablet()
        display none
    .slide
      &__text
        position absolute
        top 20px
        right 0px
        left 0px
        width 100%
        max-width 996px
        margin auto
        padding 0 100px 0 150px
        color #333
        +mobile()
          top 10px
          font-size 15px
          padding 0 30px 0 30px
      &__image
        +mobile()
          top 0px
      .feedback
        &__mobile-text
          display inline-block
          vertical-align middle
        &__image
          float left
          height 40px
          width 100px
          flex 0 0 auto
          margin-right 40px
          background-size contain
          background-position center
          background-repeat no-repeat
          +mobile()
            display inline-block
            float none
            height 80px
            width 120px
            vertical-align middle
            margin-left 40px
        &__text
          /deep/ p
            display inline
    .button
      height 64px
      width 25px
      position absolute
      top 50%
      left -62px
      transform translate(0, -50%)
      background-image url('../../assets/left_arrow.png')
      background-size contain
      background-position center
      background-repeat no-repeat
      padding 0
      +mobile()
        left 2px
        width 20px
        height 51px
      &__next
        left auto
        right -62px
        background-image url('../../assets/right_arrow.png')
        +mobile()
          right 2px
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Hero.vue